import basicController from "servicestack/basic.controller.properties";
import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";
import AutoQuery from "servicestack/auto-query/auto-query";
import "emun.invoice/parcel-picker/parcel-picker-list.htm";
import "emun.invoice/parcel-picker/parcel-picker-table.htm";
import "emun.invoice/parcel-picker/parcel-picker-grid.htm";
import "emun.invoice/parcel-picker/parcel-picker-cards.htm";

export const views = {
  list: "th-list",
  table: "table",
  cards: "th-large"
};

export default class ParcelPickerController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		Object.assign($ctrl, options);
		$ctrl.query = new AutoQuery($ctrl.getQuery());
		$ctrl.bus = $ctrl.query.bus;
		//$ctrl.viewSelectionsChanged(); //load()
	}
  getQuery() {
    console.debug("ParcelPickerController.getQuery", this);
    const $ctrl = this;
    return {
      url: `QueryParcels.json?`,
      criteria: {
        OrderNumber: $ctrl.options.orderNumber
      },
      //views,
      view: $ctrl.options.view || "table",
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      autoLoad: true,
      append: false,
      onLoaded: args => $ctrl.onLoaded(args)
    };
  }
  onLoaded(args) {
    const $ctrl = this;
  }

  templateUrl = () => `parcel-picker-${this.query.view}.htm`;

  $onDestroy() {
    this.query.dispose();
  }
}
